var map = {
	"./checkmark.svg": 51152,
	"./chevron-left.svg": 50054,
	"./chevron-right.svg": 320,
	"./credit-card.svg": 90746,
	"./error-outline.svg": 6730,
	"./error.svg": 83341,
	"./hourglass.svg": 40606,
	"./info-outline.svg": 38997,
	"./info.svg": 10964,
	"./more.svg": 88137,
	"./photo.svg": 92267,
	"./sentiment-dissatisfied.svg": 79037,
	"./sentiment-very-dissatisfied.svg": 32115,
	"./shopping-basket.svg": 87055,
	"./success-alt.svg": 46012,
	"./success.svg": 39685,
	"./warning.svg": 1974
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 97874;